<template>
  <div class="mypage-container">
    <mypage-header></mypage-header>
    <div class="w12 pt16 pr16 pb16 pl16">
      <div class="user-table">
        <div class="w12 col mt12">
          <div class="w12 label">1. {{ $t("mypage.modify.이름") }}</div>
          <div class="w12 data" flex fjb>
            <div class="inner">{{ userInfo.name || "-" }}</div>
            <router-link :to="{ name: 'leave' }" class="white link">
              회원탈퇴
            </router-link>
          </div>
        </div>
        <div class="w12 col mt16" flex fic>
          <div class="w12 label" flex fic>
            2. {{ $t("mypage.modify.이메일") }}
          </div>
          <div class="w12 data" flex fjb fic>
            <div v-if="Server.version < 10" class="inner">
              {{ emailMasking(email) }}
            </div>
            <div v-else class="inner">{{ email }}</div>
            <span class="white link" @click="pwResetModal = true">{{
              $t("mypage.modify.비밀번호 재설정")
            }}</span>
          </div>
        </div>
        <div class="w12 col mt16" flex fic>
          <div class="w12 label" flex fic>3. UID</div>
          <div class="w12 data" flex fjb fic>
            <div class="inner">{{ userInfo.uuidx }}</div>
          </div>
        </div>
        <div class="w12 col mt16" flex fic>
          <div class="w12 label" flex fic>
            4. {{ $t("mypage.modify.휴대폰 번호") }}
          </div>
          <div class="w12 data" flex fjb fic>
            <div v-if="Server.version < 10" class="inner">
              {{ phoneNumberMasking(phone) || "-" }}
            </div>
            <div v-else class="inner">{{ phone || "-" }}</div>
          </div>
        </div>
      </div>
      <div class="user-table">
        <div class="w12 col mt30" flex fic>
          <div class="w12 label mb0" flex fic>
            5. {{ $t("mypage.modify.마케팅 수신동의") }}
          </div>

          <div class="w12 data marketing" flex fjb fic>
            <div class="w12" flex fjb fic>
              <div class="inner">{{ $t("mypage.modify.이메일 설정") }}</div>
              <el-switch class="mypage" v-model="emailToggle"></el-switch>
            </div>
            <div class="w12" flex fjb fic>
              <div class="inner">{{ $t("mypage.modify.SMS 설정") }}</div>
              <el-switch class="mypage" v-model="smsToggle"></el-switch>
            </div>
            <div
              v-show="this.getMarketingAgree !== ''"
              class="w12 marketing-agree"
            >
              <div v-if="this.getMarketingAgree.M_YN == 'Y'">
                ※ 마지막 동의 일자 {{ this.getMarketingAgree.REG_DATE }}
              </div>
              <div v-else-if="this.getMarketingAgree.M_YN == 'N'">
                ※ 마지막 미동의 일자 {{ this.getMarketingAgree.REG_DATE }}
              </div>
              <div v-else></div>
            </div>
            <div class="w12 info pl7">{{ $t("mypage.modify.마켓팅설명") }}</div>
          </div>
        </div>
      </div>
      <div class="user-table mt26" v-if="false">
        <div class="w12 col" flex fic>
          <div class="label" flex fic>비대면 인증 출금</div>
          <div class="data" flex fjb fic>
            <div class="marketing p20">
              ※ 매 출금 시 비대면 본인확인 과정을 거쳐 KRW 및 암호화폐 출금이
              <br />가능하도록 설정하는 기능입니다.
            </div>

            <el-switch
              class="mypage pr20"
              v-model="authToggle"
              :disabled="true"
            ></el-switch>
          </div>
        </div>
      </div>

      <div class="button-box" flex fjc>
        <button @click="submit">{{ $t("mypage.modify.저장") }}</button>
      </div>

      <div class="w12 sub-title">7. {{ $t("mypage.modify.접속정보") }}</div>
      <div class="user-table date-box" flex fjb fic>
        <div class="w12 select-date" flex>
          <button
            class="white"
            :class="{ on: durationDays === 0 }"
            @click="dateSel('today')"
          >
            {{ $t("tradeLog.today") }}
          </button>
          <button
            class="white"
            :class="{ on: durationDays === 3 }"
            @click="dateSel(3, 'days')"
          >
            {{ $t("mypage.loginLog.date[0]") }}
          </button>
          <button
            class="white"
            :class="{ on: durationDays === 7 }"
            @click="dateSel(1, 'week')"
          >
            {{ $t("mypage.loginLog.date[1]") }}
          </button>
          <button
            class="white"
            :class="{ on: isAMonthAgo }"
            @click="dateSel(1, 'month')"
          >
            {{ $t("mypage.loginLog.date[2]") }}
          </button>
          <button
            class="white"
            :class="{ on: is3MonthAgo }"
            @click="dateSel(3, 'month')"
          >
            {{ $t("mypage.loginLog.date[3]") }}
          </button>
        </div>
        <!-- <div class="user-log date-picker" flex>
          <el-date-picker v-model="dateStart" ref="dateStart" type="date" placeholder="날짜 선택"> </el-date-picker>
          <div class="and">~</div>
          <el-date-picker v-model="dateEnd" ref="dateEnd" type="date" placeholder="날짜선택" :picker-options="pickerOptions"> </el-date-picker>
          <button @click="getList" class="gray search">{{ $t("검색") }}</button>
        </div>-->
      </div>
      <div class="user-table log-list">
        <!-- <div class="table-header" flex fic>
          <div>
            {{ $t("mypage.loginLog.dateTime") }}
          </div>
          <div>{{ $t("mypage.loginLog.loggedIn") }}</div>
          <div>{{ $t("mypage.loginLog.OS") }}</div>
          <div>{{ $t("mypage.loginLog.browser") }}</div>
          <div>{{ $t("mypage.loginLog.IPAddress") }}</div>
          <div>{{ $t("mypage.loginLog.country") }}</div>
          <div>{{ $t("mypage.loginLog.status") }}</div>
          <div>{{ $t("mypage.loginLog.index") }}</div>
        </div>-->
        <div
          class="w12"
          v-for="(list, index) in connectList"
          :key="index"
          flex
          fic
        >
          <div class="time">{{ list.time }}</div>
          <div class="w12 table" flex>
            <div class="os">
              <div class="header">{{ $t("mypage.loginLog.OS") }}</div>
              <div
                class="data"
                style="
                  height: 44px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ list.os }}
              </div>
            </div>
            <div class="browser">
              <div class="header">{{ $t("mypage.loginLog.browser") }}</div>
              <div
                class="data"
                style="
                  height: 44px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ list.browser }}
              </div>
            </div>
            <div class="ip">
              <div class="header">{{ $t("mypage.loginLog.IPAddress") }}</div>
              <div
                class="data"
                style="
                  height: 44px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ list.ip }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w12 mt30" flex fjc>
        <el-pagination
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="pageChange"
        ></el-pagination>
        <!-- <div is="uib-pagination" :boundary-links="true" :total-items="pagination.total" :max-size="10" :items-per-page="pagination.countPerPage" v-model="page" @change="getList({ page: page.currentPage })"></div> -->
      </div>

      <div class="noti-box info black mb20">
        <div class="noti-title ml0 mb0 pb5" flex fic>
          <img src="../../assets/img/mypage/exclamationmark.png" alt />
          {{ $t("mypage.modify.이용안내.제목") }}
        </div>
        <ul class="w12 no-dot">
          <li class="w12" v-html="$t('mypage.modify.이용안내.내용[0]')"></li>
          <li class="w12" v-html="$t('mypage.modify.이용안내.내용[1]')"></li>
          <li class="w12" v-html="$t('mypage.modify.이용안내.내용[2]')"></li>
        </ul>
      </div>
    </div>

    <el-dialog
      :title="$t('resetPassword.title')"
      :visible.sync="pwResetModal"
      :show-close="false"
      :close-on-click-modal="false"
      class="modal-type01 popup"
      center
    >
      <div class="text-left">
        <p class="size-13 text-type02 mgb25">
          {{ $t("resetPassword.Log out to reset") }}
          <br />
          {{ $t("resetPassword.Please check the password") }}
        </p>
        <p class="text-type02">
          <strong class="txt-blue">{{
            $t("resetPassword.apply for a password reset")
          }}</strong>
        </p>
      </div>
      <div slot="footer" class="dialog-footer" flex fjc>
        <button class="cancel gray" @click="pwResetModal = false">
          {{ $t("confirm.no") }}
        </button>
        <button class="submit" @click="pwReset">{{ $t("confirm.yes") }}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Api from "@/common/Api";
import Moment from "moment";
import Bowser from "bowser";
import MypageHeader from "./component/mypage/header.vue";
import Masking from "@/common/masking.js";

export default {
  components: {
    MypageHeader,
  },
  data() {
    return {
      dateStart: Moment()
        .startOf("day")
        .toDate(),
      dateEnd: Moment()
        .endOf("day")
        .toDate(),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      connectList: [],
      pagination: {},
      page: {},

      onSubmit: false,
      emailConfirm: false,
      pwResetModal: false,
      modifyForm: {
        M_PASSWD: "",
        M_PASSWD_NEW: "",
        M_PASSWD_CONFIRM: "",
      },
      email: "",
      phone: "",
      emailToggle: true,
      smsToggle: true,
      authToggle: false,

      loginContent: true,
      getMarketingAgree: {},
    };
  },
  created() {
    this.marketingAgree();

    // if (!this.isLogin) {
    //   this.$router.back();
    // }

    this.emailToggle =
      _.get(this, ["userInfo", "configInfo", "emailSend"], "N") === "Y";
    this.smsToggle =
      _.get(this, ["userInfo", "configInfo", "smsSend"], "N") === "Y";

    this.getUserPrivateInfo();
    this.getList({});
  },
  computed: {
    ...mapGetters(["userInfo"]),
    ...mapState(["Server"]),
    durationDays() {
      return parseInt(Moment.duration(this.dateEnd - this.dateStart).as("d"));
    },
    isAMonthAgo() {
      const ago = Moment(this.dateEnd)
        .subtract(1, "month")
        .startOf("day");
      return +Moment(this.dateStart).startOf("day") === +ago;
    },
    is3MonthAgo() {
      const ago = Moment(this.dateEnd)
        .subtract(3, "months")
        .startOf("day");
      return +Moment(this.dateStart).startOf("day") === +ago;
    },
  },
  methods: {
    dateSel(duration, unit) {
      this.dateEnd = Moment()
        .endOf("day")
        .toDate();
      this.dateStart = Moment()
        .subtract(duration, unit)
        .startOf("day")
        .toDate();

      this.getList({});
    },
    pageChange(page) {
      this.getList({ page });
    },
    getList({ page = 1, count = 10 }) {
      const startDate = Moment(this.dateStart).toISOString();
      const endDate = Moment(this.dateEnd)
        .endOf("day")
        .toISOString();
      Api.User.getConnectionInfo({ page, count, startDate, endDate }).then(
        (response) => {
          this.pagination = response.pagination;
          const connectList = response.body;
          this.connectList = _.map(connectList, (connectInfo) => {
            const BowserResult = Bowser.getParser(connectInfo.agent);

            const connect = mobileAndTabletcheck(connectInfo.agent)
              ? "모바일"
              : "PC";
            const os =
              BowserResult.parsedResult.os.name +
              BowserResult.parsedResult.os.version;
            const browser = `${BowserResult.parsedResult.browser.name} ${BowserResult.parsedResult.browser.version}`;
            return {
              ...connectInfo,
              connect,
              os,
              browser,
            };
          });
        }
      );
    },
    getUserPrivateInfo() {
      Promise.all([
        Api.User.getUserPrivateInfo("email"),
        Api.User.getUserPrivateInfo("phone"),
      ]).then(([email, phone]) => {
        this.email = email.body.data;
        this.phone = phone.body.data;
      });
    },
    submit() {
      if (this.onSubmit) {
        return false;
      }

      // const modifyForm = this.$refs.modifyForm;
      this.onSubmit = true;

      // if (this.modifyForm.M_PASSWD) {
      //   // 새 비밀번호 저장
      //   modifyForm.validate(valid => {
      //     this.onSubmit = false;
      //     if (valid) {
      //       Api.User.updateUserInfo({
      //         oldPassword: this.modifyForm.M_PASSWD,
      //         newPassword: this.modifyForm.M_PASSWD_NEW,
      //         emailToggle: this.emailToggle ? "Y" : "N",
      //         smsToggle: this.smsToggle ? "Y" : "N"
      //       });
      //     } else {
      //       return false;
      //     }
      //   });
      // } else {
      // 설정만 저장
      Api.User.updateUserInfo({
        agreeEmail: this.emailToggle ? "Y" : "N",
        agreeSms: this.smsToggle ? "Y" : "N",
      })
        .then((res) => {
          this.$store.dispatch("updateUserInfo");
          this.$vs.notify({
            title: this.$t("notice.title.done"),
            text: this.$t("notice.content.settingChanged"),
            position: "top-left",
          });
          this.marketingAgree();
        })
        .finally(() => {
          this.onSubmit = false;
        });
      // }
    },
    marketingAgree() {
      Api.User.getMarketingAgree().then((response) => {
        this.getMarketingAgree = response.body;
      });
    },
    pwReset() {
      const email = this.email;
      this.$router.push({ name: "PwReset", params: { email } });

      // return this.$store
      //   .dispatch("logOut")
      //   .then(() => {
      //     this.pwResetModal = false;
      //     this.$router.push({ name: "PwReset", params: { email } });
      //   })
      //   .catch((e) => {
      //     // this.$message({message: e.msg});
      //     this.$notify({
      //       title: this.$t("notice.title.attention"),
      //       message: e.msg,
      //       type: "warning",
      //       customClass: "dexko-noti",
      //       position: "top-left",
      //     });
      //   });
    },
    // 이메일 마스킹 : @앞 세 자리
    emailMasking(_value) {
      return Masking.emailMasking(_value);
    },
    // 전화번호 마스킹 : 뒤 3자부터 4자
    phoneNumberMasking(_value) {
      return Masking.phoneNumberMasking(_value);
    },
  },
};

function mobileAndTabletcheck(agent) {
  var check = false;
  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(agent);
  return check;
}
</script>

<style scoped lang="scss" src="./index.scss"></style>
